import React, {Component} from 'react'
import Image from "../../../../common/image/image.component.jsx"
import ProposalMergeFields from "../../../MergeFields.jsx";
import SectionWrapper from "../../sectionwrapper.component.jsx";
import { injectIntl } from "react-intl"
class TextAndImageContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            section: this.props.section || null,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            isPdf: this.props.isPdf || false,
            isDummy: this.props.isDummy || false,
            onEdit: this.props.onEdit || function(){},
            id: this.props.id || '',
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            isPdf: nextProps.isPdf || false,
            isDummy: nextProps.isDummy || false,
            id: nextProps.id || '',
        })
    }

    render() {
        if (!this.state.section) {
            return <div />
        }

        let nbColLargeSizeText = 6 //bootstrap column width for large (md-sized +) screens
        let nbColLargeSizeImage = 6 //bootstrap column width for large (md-sized +) screens
        let nbColSmallSizeText = 12//bootstrap column width for small (xs & sm-sized) screens
        let nbColSmallSizeImage = 12//bootstrap column width for small (xs & sm-sized) screens
        switch (this.state.section.attributes.content.imageSize) {
            case "15":
                nbColLargeSizeText = 10
                nbColLargeSizeImage = 2
                break
            case "25":
                nbColLargeSizeText = 9
                nbColLargeSizeImage = 3
                break
            case "50":
                nbColLargeSizeText = 6
                nbColLargeSizeImage = 6
                break
            case "75":
                nbColLargeSizeText = 3
                nbColLargeSizeImage = 9
                break
        }
        if(this.state.isPdf) {
            switch (this.state.section.attributes.content.imageSize) {
                case "15":
                    nbColSmallSizeText = 10
                    nbColSmallSizeImage = 2
                    break
                case "25":
                    nbColSmallSizeText = 9
                    nbColSmallSizeImage = 3
                    break
                case "50":
                    nbColSmallSizeText = 6
                    nbColSmallSizeImage = 6
                    break
                case "75":
                    nbColSmallSizeText = 3
                    nbColSmallSizeImage = 9
                    break
            }
            nbColLargeSizeText = nbColSmallSizeText
            nbColLargeSizeImage = nbColSmallSizeImage
        }

        const borderRadius = this.state.section.attributes.content.borderRadius || '0'
        const cols = [
            <div key={1} className={'py-2 col-'+ nbColSmallSizeImage +' col-md-' + nbColLargeSizeImage}>
                <Image
                    imageId={this.state.section.attributes.content.imageId}
                    image={this.state.section.attributes.content.image}
                    size="large"
                    imageClassName="w-100"
                    rounded={false}
                    style={{borderRadius: borderRadius + '%'}}
                />
            </div>,
        ]
        const text = <div key={2} className={'col-'+ nbColSmallSizeText +' col-md-' + nbColLargeSizeText + ' rich-text'} >
            <div dangerouslySetInnerHTML={{__html: ProposalMergeFields.merge(this.state.section.attributes.content.text, this.state.variables, this.state.isDummy, this.props.intl)}} />
        </div>
        if (this.state.section.attributes.content.imagePosition === "left") {
            cols.push(text)
        } else {
            cols.unshift(text)
        }

        let alignment = "align-items-center"
        switch (this.state.section.attributes.content.alignment) {
            case 'middle':
                alignment = "align-items-center"
                break
            case 'top':
                alignment = "align-items-start"
                break
            case 'right':
                alignment = "align-items-end"
                break
        }

        let style = {}
        if (this.state.section.attributes.content.backgroundColor) {
            style.backgroundColor = this.state.section.attributes.content.backgroundColor
        }

        return (
            <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
                style={style}
            >
                <div className={'col-12'}>
                    <div className={'row ' + alignment}>
                        {cols}
                    </div>
                </div>
            </SectionWrapper>
        );
    }
}

export default injectIntl(TextAndImageContentSection)


// WEBPACK FOOTER //
// ./src/template/sections/content/text-and-image/section.component.jsx